import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, filter) => {
  try {
    const endpoint = filter?.whitelabelId ? 'tax-whitelabel' : 'tax'
    const { data } = await axios.get(endpoint, {
      params: filter,
    })

    if (data?.taxes) {
      commit('setRows', data.taxes)

      return data.taxes
    }

    return null
  } catch (err) {
    return err
  }
}

export const findById = async ({ commit }, payload) => {
  try {
    const id = typeof payload === 'object' ? payload?.id : payload
    const whitelabelId = typeof payload === 'object' ? payload?.whitelabelId : null
    const endpoint = whitelabelId ? `tax-whitelabel/${id}` : `tax/${id}`
    const { data } = await axios.get(endpoint, {
      params: whitelabelId ? { whitelabelId } : undefined,
    })

    if (data?.tax) {
      commit('setRow', data.tax)

      return data.tax
    }

    return null
  } catch (err) {
    return err
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const endpoint = body?.whitelabelId ? 'tax-whitelabel' : 'tax'
    return await axios.post(endpoint, body)
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const update = async ({ state }, body) => {
  Vue.prototype.$loading(true)

  try {
    const endpoint = body?.whitelabelId ? `tax-whitelabel/${state.row.id}` : `tax/${state.row.id}`
    return await axios.put(endpoint, body)
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const remove = async (_, payload) => {
  Vue.prototype.$loading(true)

  try {
    const id = typeof payload === 'object' ? payload?.id : payload
    const whitelabelId = typeof payload === 'object' ? payload?.whitelabelId : null
    const endpoint = whitelabelId ? `tax-whitelabel/${id}` : `tax/${id}`
    return await axios.delete(endpoint, {
      params: whitelabelId ? { whitelabelId } : undefined,
    })
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
